import { Badge } from '@chakra-ui/react'
import type { FollowUpKind } from '../../../types/followUp'
import { followUpKindLabel } from './followUpKindLabel'

export function FollowUpKindBadge({ kind, customName }: { kind: FollowUpKind; customName?: string | null }) {
  return (
    <Badge variant="subtle" bg="info.subtle" color="info.fg" size="sm" fontSize="2xs" maxW="100%" lineClamp={1}>
      {followUpKindLabel(kind, customName)}
    </Badge>
  )
}
